const module = [
  {
    importSagas: () => [],
  },
];

export default module;
